// extracted by mini-css-extract-plugin
export default {"report-error-modal":"ReportErrorModal_report-error-modal__Jaj4d","submit-btn":"ReportErrorModal_submit-btn__u8aSh","reason-input":"ReportErrorModal_reason-input__rc178"};